module.exports = __webpack_public_path__ + "static/media/freeMinds2.5f63b808.jpg";